/* eslint-disable no-empty-function */
/* eslint-disable no-useless-constructor */
import { AxiosInstance } from "axios";
import { ReplaySubject } from "rxjs";

/**
 * Aggregates network requests such that only a single request is performed for each unique request
 * Stateful class, should be used as a singleton for each
 */
export class RequestAggregator<ReturnPayloadType, GetRequestUrlOptions extends unknown> {
    /**
     * @param api The api to run the request from
     * @param getRequestUrl Function to get the request URL
     */
    constructor(private api: AxiosInstance, private getRequestUrl: (options: GetRequestUrlOptions) => string) {}

    private pendingRequests: { [url: string]: ReplaySubject<ReturnPayloadType> } = {};

    public get(getRequestUrlOptions: GetRequestUrlOptions) {
        const url = this.getRequestUrl(getRequestUrlOptions);

        if (this.pendingRequests[url] === undefined) {
            const subject = new ReplaySubject<ReturnPayloadType>();
            this.pendingRequests[url] = subject;

            this.api.get(url).then((response) => subject.next(response.data));
        }

        return this.pendingRequests[url];
    }
}
